import state from "./state"

export const user = state => state.user
export const pageWidth = state => state.pageWidth
export const language = state => state.language
export const bannerList = state => state.bannerList
export const storage = state => state.storage